module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Dish-65ebe25075c86221eebd898374e6e2fb.svg";